<template>
    <div class="column">
        <div class="card tilebox-one">
            <div class="card-body">
                <i class="dripicons-basket float-end text-muted"></i>
                <h6 class="text-muted text-uppercase mt-0">Potential Bonus</h6>
                <h2 class="m-b-20" style="margin-bottom: 20px;">$<animated-number :value="+potentialBonus" /></h2>
            </div>
        </div>
    </div>
</template>
<script>
import AnimatedNumber from '../../../../components/AnimatedNumber.vue'

    export default {
        components: {
            AnimatedNumber
        },
        props: {
            year: null,
            month: null,
            user: {},
            efRating: 0
        },
        data() {
            return {
                
            }
            
        },
        methods: {

        },
        watch: {
            'efRating'(value) {
                
            }
        },
        computed: {
          /*
          * esta propiedad te devuelve un potential bonus que funciona con la siguiente formula (efRating - la cantidad mas grande de la primera casilla * el bonus)
          */
            potentialBonus() {
              // esta condicion es por si el resultado es negativo funcione con la siguiente formula (el bonus de ese rango * efRating)
              if(this.efRating >= this.user.bonus_data[0].from  && this.efRating <= this.user.bonus_data[0].to){
                return this.user.bonus_data[0].bonus * this.efRating
              }
              else{
                return this.user.bonus_data.filter(p => this.efRating >= +p.from  && this.efRating <= +p.to)
                    .map((value) => Math.abs((this.efRating - +this.user.bonus_data[0].to) * +value.bonus))
              }
            },
        }
    }
</script>